// import pacchetti
import { useEffect, useState } from "react";
import { database } from "../firebase/config";

export const useDocument = (collection, id) => {
  const [document, setDocument] = useState(null);
  const [error, setError] = useState(null);

  // realtime data from the document
  useEffect(() => {
    if (!collection || !id) {
      setDocument(null);
      setError(null);
      return () => {};
    }

    const ref = database.collection(collection).doc(id);

    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        if (snapshot.data()) {
          setDocument({ ...snapshot.data(), id: snapshot.id });
          setError(null);
        } else {
          setError("Il documento selezionato non esiste");
        }
      },
      (err) => {
        console.log(err.message);
        setError("Impossibile recuperare il documento");
      }
    );
    return () => unsubscribe();
  }, [collection, id]);

  return { document, error };
};
